'use strict';

export class CheckListItem {

  id: number;
  kod: string;
  popis: string;

  vybrany: boolean;
}
